import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import { EditIcon } from 'components/Icon';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import theme from "./NextCheckInDate.module.sass";
import styleVars_20 from "styles/colors.module.scss";
const { orange01  } = styleVars_20;;

const NextCheckInDate = ({
  date,
  onChange,
}) => {
  const [editingCheckIn, setEditingCheckIn] = useState(false);
  return (
    <>
      <p>Next Check-in: <em>{date}</em>
        {!editingCheckIn &&
          <Button
            color="sensitive"
            classes={[theme.EditCheckin]}
            onClick={() => { setEditingCheckIn(true); }}
          >
            <EditIcon width={18} height={18} fill={orange01} />
          </Button>
        }
      </p>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          slotProps={{
            textField: { className: theme.BirthDateInput }
          }}
          disablePast
          onClose={() => { setEditingCheckIn(false); }}
          open={editingCheckIn}
          value={date ? new Date(date) : null}
          onChange={onChange}
        />
      </LocalizationProvider>
    </>
  );
};

NextCheckInDate.propTypes = {
  date: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NextCheckInDate;